export default "__VITE_ASSET__CDWQ9wMG__"